import { axios, Response } from '../index'

const requestToJoinGroup = (groupId: string): Response<null> => {
  return axios.post(`/v1/groups/${groupId}/membership-requests`)
}

export default requestToJoinGroup
